import { Breadcrumbs } from "../../../../src/components/breadcrumbs";
interface ShopHeaderProps {
  categoryName?: string;

  categoryId?: string;

  mobile?: boolean;
  searchQuery?: string;
}

export function ShopHeader({
  categoryName,

  categoryId,

  mobile,
  searchQuery,
}: ShopHeaderProps) {
  return (
    <div
      className={
        mobile
          ? "flex flex-col gap-2 p-5 mt-5"
          : "flex flex-col gap-2 mt-10"
      }
    >
      <h1 className="sm:text-2xl text-xl font-montserrat font-medium">
        SHOP
      </h1>

      {!categoryName ? (
        <Breadcrumbs type={"shop"} />
      ) : (
        <Breadcrumbs
          categoryName={categoryName}
          categoryId={categoryId}
        />
      )}
    </div>
  );
}
